import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./login.css";

const Login = () => {
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    // ================= VALIDATION =================
    const validate = () => {
        const newErrors = {};
        if (!username.trim()) newErrors.username = "Username or Email is required";
        if (!password.trim()) newErrors.password = "Password is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ================= LOGIN =================
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        // ✅ STATIC ADMIN LOGIN
        if (username === "admin@gmail.com" && password === "Admin@123") {
            const adminUser = {
                id: "admin001",
                name: "Super Admin",
                email: "admin@gmail.com",
                role: "admin",
            };

            localStorage.setItem("token", "static-admin-token");
            localStorage.setItem("user", JSON.stringify(adminUser));
            localStorage.setItem("role", "admin");
            localStorage.setItem("email", adminUser.email);
            localStorage.setItem("fullName", adminUser.name);

            navigate("/admin");
            return;
        }

        // ✅ DYNAMIC USER LOGIN (admin created users)
        try {
            setLoading(true);

            const res = await fetch(
                `${process.env.REACT_APP_API_URL || "http://localhost:8000"}/api/auth/login`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        username: username.trim(), // username or email both work
                        password: password.trim(),
                    }),
                }
            );

            const data = await res.json();

            if (!res.ok) {
                setErrors({ general: data.message || "Invalid credentials" });
                return;
            }

            // ✅ Save Token
            localStorage.setItem("token", data.token || data.accessToken);

            // ✅ Save User Info
            localStorage.setItem("user", JSON.stringify(data.user));
            localStorage.setItem("role", data.user.role || "reporter");
            localStorage.setItem("email", data.user.email);

            if (data.user.name || data.user.fullName) {
                localStorage.setItem("fullName", data.user.name || data.user.fullName);
            }

            if (data.user.id || data.user._id) {
                localStorage.setItem("userId", data.user.id || data.user._id);
            }

            // ✅ Role based navigation
            const role = data.user.role;
            if (role === "admin") {
                navigate("/admin");
            } else if (role === "reporter" || role === "user") {
                navigate("/user-panel"); // reporter/user dashboard
            } else {
                navigate("/user-panel"); // default to user panel
            }

        } catch (error) {
            setErrors({ general: "Server error. Please try again." });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-container">
            <div className="login-container">

                {/* LEFT PANEL */}
                <div className="left-panel">
                    <h1>Welcome Page</h1>
                    <p>Sign In To Your Account</p>
                </div>

                {/* RIGHT PANEL */}
                <div className="right-panel">
                   

                    <p className="login-text">
                        <span>Login</span> Your Account
                    </p>

                    {/* GENERAL ERROR */}
                    {errors.general && (
                        <div className="error-box">{errors.general}</div>
                    )}

                    <form onSubmit={handleSubmit}>

                        {/* USERNAME / EMAIL */}
                        <input
                            type="text"
                            placeholder="Username or Email"
                            value={username}
                            onChange={(e) => {
                                setUsername(e.target.value);
                                setErrors((prev) => ({ ...prev, username: "" }));
                            }}
                            className={errors.username ? "input-error" : ""}
                        />
                        {errors.username && (
                            <div className="field-error">{errors.username}</div>
                        )}

                        {/* PASSWORD */}
                        <div className="password-field">
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setErrors((prev) => ({ ...prev, password: "" }));
                                }}
                                className={errors.password ? "input-error" : ""}
                            />
                            <span
                                className="eye-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                        {errors.password && (
                            <div className="field-error">{errors.password}</div>
                        )}

                        {/* FORGOT PASSWORD */}
                        <div className="options">
                            <Link to="/forgot-password" className="forgot-link">
                                Forgot Password?
                            </Link>
                        </div>

                        {/* BUTTON */}
                        <button type="submit" disabled={loading}>
                            {loading ? "Logging in..." : "Login"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;